import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { useParams } from "react-router-dom";

import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import DownloadFormA from "../FormA/DownloadFormA.component";
import { contractorFormAFields, initialContractorFormA } from "./Constant";
import { getContractorPersonFormAHistoryByID } from "app/_services/UserManagement/ContractorPersonService";
import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";

function ViewContractorFormAHistory() {
  const { id } = useParams();

  const [data, setData] = useState({
    ...initialContractorFormA,
  });

  useEffect(() => {
    if (!id) return;

    getContractorPersonFormAHistoryByID(id).then((response) => {
      if (!response?.data?.dataJson) return;
      const historyData = JSON.parse(response.data.dataJson);

      setData((prev) => ({
        ...prev,
        ...historyData,
        startDateAtMines: historyData.startDateAtMines?.slice(0, 10) || "",
        dateOfJoining: historyData.dateOfJoining?.slice(0, 10) || "",
        dateOfSeparation: historyData.dateOfSeparation?.slice(0, 10) || "",
        siteType: response.data.site?.siteType || "",
        mineName: response.data.site?.name || "",
        mineCode: response.data.site?.siteId || "",
        fullName: `${historyData.firstName || ""} ${historyData.lastName || ""}`,
        contractorName: historyData.contractors?.contactPerson || "",
        contractorCode: historyData.contractors?.contractorCode || "",
        profilePicture: historyData.profilePicture
          ? `${URL_CONFIG.IMG_URL}${historyData.profilePicture}`
          : "",
      }));
    });
  }, [id]);

  return (
    <div>
      <MainBreadcrumb
        routeSegments={[
          { name: "User Management", path: "#" },
          { name: "Contractor", path: "/user-management/contractor-person" },
          { name: "View Contractor Form A History", path: "#" },
        ]}
      />
      <Card className="overflow-inherit">
        <Card.Body>
          <Card.Title className="simple-card-title mb-0">
            <h3 class="text-capitalize mb-1">View Contractor Form A History</h3>
          </Card.Title>
          <DownloadFormA fieldsObj={contractorFormAFields} data={data} />
        </Card.Body>
      </Card>
    </div>
  );
}

export default ViewContractorFormAHistory;
